/**
 * Hero Banner — Parallax + Trust Bar Slider
 * Distantlines Shopify Store
 */
(function() {
  'use strict';

  // ── Parallax on desktop ──
  function initParallax() {
    var hero = document.querySelector('.hero-banner');
    var frames = document.querySelectorAll('.hero-banner__frame');
    if (!hero || frames.length < 2) return;

    // Disable on touch devices
    if ('ontouchstart' in window) return;

    hero.addEventListener('mousemove', function(e) {
      var rect = hero.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;

      frames[0].style.transform = 'translate(' + (x * -8) + 'px, ' + (y * -6) + 'px)';
      frames[1].style.transform = 'translate(' + (x * 5) + 'px, ' + (y * 4) + 'px)';
    });

    hero.addEventListener('mouseleave', function() {
      frames[0].style.transform = '';
      frames[1].style.transform = '';
    });
  }

  // ── Trust bar slide rotation (mobile) ──
  function initTrustSlider() {
    var slider = document.querySelector('.hero-banner__trust-slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.hero-banner__trust-slide');
    if (slides.length === 0) return;

    var current = 0;

    // Set first slide active
    slides[0].classList.add('is-active');

    setInterval(function() {
      var prev = current;
      current = (current + 1) % slides.length;

      // Current slide leaves to the left
      slides[prev].classList.add('is-leaving');
      slides[prev].classList.remove('is-active');

      // After transition, reset the leaving slide
      setTimeout(function() {
        slides[prev].classList.remove('is-leaving');
        // Reset position to right (for next entrance)
        slides[prev].style.transform = 'translateX(40px)';
        slides[prev].style.opacity = '0';

        // Small delay then clear inline styles so CSS transition class takes over
        setTimeout(function() {
          slides[prev].style.transform = '';
          slides[prev].style.opacity = '';
        }, 50);
      }, 500);

      // New slide enters from the right
      slides[current].classList.add('is-active');
    }, 3000);
  }

  // ── Init ──
  function init() {
    initParallax();
    initTrustSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
